import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

/**
 * Login DTO Schema for email/password authentication
 */
export const LoginDtoSchema = z
    .object({
        /** User email address */
        email: z.string().email('Invalid email format').toLowerCase(),

        /** User password */
        password: z.string().min(1, 'Password is required'),
    })
    .strict();

/**
 * Login DTO for email/password authentication
 */
export class LoginDto extends FromSchema(LoginDtoSchema) {
    email: string;
    password: string;
}
